import getArgs from './src/getArgs';

export { getArgs };
